module.exports = __webpack_public_path__ + "img/consultbg.a1f3fd20.png";